// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__6NG2T","item":"styles_item__cV4QA","active":"styles_active___fZjO","label":"styles_label__P9T6D"};